module.exports = __webpack_public_path__ + "img/catherine.5380892d.png";